import { h3ProjectionFunctions } from '../../../utils/materials/vertex-shaders/h3-projection';
import { sharedUniforms } from '../../shared/shaders/definitions';

// excerpt from
// https://github.com/mrdoob/three.js/blob/r155/src/renderers/shaders/ShaderLib/meshbasic.glsl.js#L1
export const h3MainSharedVertexShader = /* glsl */ `
    #include <common>
    #include <uv_pars_vertex>
    #include <envmap_pars_vertex>
    #include <color_pars_vertex>
    #include <fog_pars_vertex>
    #include <morphtarget_pars_vertex>
    #include <skinning_pars_vertex>
    #include <logdepthbuf_pars_vertex>
    #include <clipping_planes_pars_vertex>

    ${sharedUniforms}
    ${h3ProjectionFunctions}

    void main() {
        #include <uv_vertex>
        #include <color_vertex>
        #include <morphcolor_vertex>

        #if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )

            #include <beginnormal_vertex>
            #include <morphnormal_vertex>
            #include <skinbase_vertex>
            #include <skinnormal_vertex>
            #include <defaultnormal_vertex>

        #endif

        #include <begin_vertex>
        #include <morphtarget_vertex>
        #include <skinning_vertex>
        #include <project_vertex>
        #include <logdepthbuf_vertex>
        #include <clipping_planes_vertex>

        #include <worldpos_vertex>
        #include <envmap_vertex>
        #include <fog_vertex>

        gl_Position = getProjection(projectionMatrix, viewMatrix);
    }
`;
